<template>
    <card>
      <template class="card-header" slot="header">
        <h4 class="card-title">
          Application Information
          <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
            <font-awesome-icon icon="sync"></font-awesome-icon>
          </button>
        </h4>
        <p class="card-category">General information about this application.</p>
      </template>
      <table class="table table-borderless beast-info-table">
        <tr>
          <th class="beast-key">Application Name:</th>
          <td class="beast-value">{{appInfo.appName}}</td>
        </tr>
        <tr>
          <th class="beast-key">Version:</th>
          <td class="beast-value">{{appInfo.version}}</td>
        </tr>
        <tr v-if="!noEnv">
          <th class="beast-key">Environment:</th>
          <td class="beast-value">{{appInfo.environment}}</td>
        </tr>
        <tr>
          <th class="beast-key">Framework Name:</th>
          <td class="beast-value">{{appInfo.framework}}</td>
        </tr>
        <tr>
          <th class="beast-key">Framework Version:</th>
          <td class="beast-value">{{appInfo.frameworkVersion}}</td>
        </tr>
      </table>
    </card>
</template>

<script>
export default {
  props: {
    appInfo: {
      type: Object,
      required: true
    },
    noEnv: {
      type: Boolean,
      default: false
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  name: "AppInfo"
};
</script>

<style scoped>

</style>
